import React from 'react'
import { Main } from './components'

const StockMovements = () => <Main />

export default StockMovements
